import { Checkbox, Drawer, Input, message, Select, Space } from 'antd';
import React, { useContext, useEffect } from 'react';
import { Button, Form } from 'antd';
import { useInternalClientServiceGetInternalClient, useTemplateServicePostTemplate, useInternalTemplateTypeServiceGetInternalTemplateType, useSceneServiceGetScene, useTemplateServiceGetTemplate } from '../../openapi/queries';
import { TemplateEditDTO } from '../../openapi/requests';
import { ConfigContext } from '../../contexts/ConfigContext';
import { TemplatePresetCreateDTO } from '../../backendapi/requests';
import { useTemplatePresetsServicePostBackendv2Templatepreset, useTemplatesServiceGetBackendv2Template } from '../../backendapi/queries';
import TextArea from 'antd/es/input/TextArea';


const CreateTemplatePreset: React.FC<{ isOpen: boolean, onClose: () => void, templateId: number | undefined, config: string | undefined }> = ({ isOpen, onClose, templateId, config }) => {
 
    const { currentClient } = useContext(ConfigContext);   
    const {data: templates} = useTemplatesServiceGetBackendv2Template({clientId: currentClient.id}, undefined, {enabled: isOpen});
    const [form] = Form.useForm<TemplatePresetCreateDTO>();
    const [messageApi, contextHolder] = message.useMessage();
    const {mutateAsync: createTemplatePreset, isPending } = useTemplatePresetsServicePostBackendv2Templatepreset();

    const onSubmit = () => {
        form.submit();
    };

    const onFinish = () => {
        const template = form.getFieldsValue(true) as TemplatePresetCreateDTO;
        createTemplatePreset({requestBody: template})
            .then(() => {
                messageApi.success("preset created");
                onClose();
            }).catch(reason => {
                messageApi.error(JSON.stringify(reason));
            });
    };

    useEffect(() => {
        form.setFieldValue("templateId", templateId);
    }, [templateId]);

    useEffect(() => {
        form.setFieldValue("configurationSpec", config);
    }, [config]);

    return (
        <>
            {contextHolder}

            <Drawer
                title="Create a new preset"
                size={720}
                onClose={onClose}
                open={isOpen}
                extra={
                    <Space>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button onClick={onSubmit} type="primary" loading={isPending}>
                            Submit
                        </Button>
                    </Space>
                }
            >
                <Form
                    name="basic"
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}>

                    <Form.Item rules={[{required: true}]} name='title' label="Title">
                        <Input />
                    </Form.Item>

                    <Form.Item name="isEnabled" valuePropName="checked">
                        <Checkbox>Enabled</Checkbox>
                    </Form.Item>

                    <Form.Item name='templateId' label="Template">
                        <Select allowClear options={templates?.value.map(e => ({ label: e.title, value: e.id }))} />
                    </Form.Item>

                    <Form.Item name='configurationSpec' label="Configuration">
                        <TextArea rows={6} />
                    </Form.Item>

                    <Form.Item name="autoRenderEnabledCameras" valuePropName="checked">
                        <Checkbox>Render enabled cameras</Checkbox>
                    </Form.Item>
                                        
                    <Form.Item name="autoRenderDisabledCameras" valuePropName="checked">
                        <Checkbox>Render disabled cameras</Checkbox>
                    </Form.Item>
                </Form>
            </Drawer>
        </>

    );
};

export default CreateTemplatePreset;